import scrollSpy from './components/scrollspy';
import diaporama from './components/diaporama';
import videoFrame from './components/video';

scrollSpy.init();
diaporama.init();
videoFrame.init();
